import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AccountAdminApiV2 } from '../../../../../../lib/api/account/admin/AccountAdminApiV2';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { AdminInfoType } from '../../types/AccountAdminFormType';

type UseAccountAdminQueryParamsType<SelectResultType> = {
  id: number;
  options: QueryOptions<AdminInfoType, Error, SelectResultType>;
};
export const useAccountAdminInformation = <SelectResultType>(
  props: UseAccountAdminQueryParamsType<SelectResultType>,
): UseQueryResult => {
  const { id, options } = props;
  return useQuery<AdminInfoType, Error, SelectResultType>(
    ['accountAdminInfo', id],
    () => AccountAdminApiV2.getAccountAdminDetailInfo(id),
    {
      ...options,
    },
  );
};
